import { FC, PropsWithChildren } from 'react'

import { Checkbox } from '@ui/components/Checkbox'

import { Box } from '@shared/components/Box'

interface Props extends PropsWithChildren {
  isCheckboxDisabled?: boolean
  onCheckboxClick?: () => void
}

export const TableActionsBox: FC<Props> = (props) => {
  const { isCheckboxDisabled } = props
  const { onCheckboxClick, children } = props

  return (
    <Box
      bg='surface-black'
      gap='x8'
      flex
      align='center'
      px='x12'
      py='x8'
      radius='round'
      mt='x16'
      fullWidth
    >
      <Checkbox
        onChange={onCheckboxClick}
        intermediate
        checked={false}
        disabled={isCheckboxDisabled}
        size='sm'
      />

      {children}
    </Box>
  )
}
